export enum EGameStates {
    GAME_START = 'GAME_START',
    IDLE_STATE = 'IDLE_STATE',
    PRE_SPIN_STATE = 'PRE_SPIN_STATE',
    SPIN_STATE = 'SPIN_STATE',
    POST_SPIN_STATE = 'POST_SPIN_STATE',
    COMPLETE_SPIN_STATE = 'COMPLETE_SPIN_STATE',
    PRE_WIN_STATE = 'PRE_WIN_STATE',
    PRE_WIN_STEP_STATE = 'PRE_WIN_STEP_STATE',
    PRE_WIN_FEATURES_STATE = 'PRE_WIN_FEATURES_STATE',
    WIN_STATE = 'WIN_STATE',
    POST_WIN_STEP_STATE = 'POST_WIN_STEP_STATE',
    POST_WIN_STATE = 'POST_WIN_STATE',
    POST_WIN_FEATURES_STATE = 'POST_WIN_FEATURES_STATE',
    COMPLETE_WIN_STATE = 'COMPLETE_WIN_STATE',
    PRE_GAMBLE_STATE = 'PRE_GAMBLE_STATE',
    GAMBLE_STATE = 'GAMBLE_STATE',
    GAMBLE_RESULT_STATE = 'GAMBLE_RESULT_STATE',
    POST_GAMBLE_STATE = 'POST_GAMBLE_STATE',
    COMPLETE_GAMBLE_STATE = 'COMPLETE_GAMBLE_STATE',

    PRE_WILD_WHEEL_STATE = 'PRE_WILD_WHEEL_STATE',
    WILD_WHEEL_STATE = 'WILD_WHEEL_STATE',
    POST_WILD_WHEEL_STATE = 'POST_WILD_WHEEL_STATE',

    PRE_EXPANDING_SYMBOL_STATE = 'PRE_EXPANDING_SYMBOL_STATE',
    EXPANDING_SYMBOL_STATE = 'EXPANDING_SYMBOL_STATE',
    POST_EXPANDING_SYMBOL_STATE = 'POST_EXPANDING_SYMBOL_STATE',

    PRE_BEFORE_WIN_ANIMATION_STATE = 'PRE_BEFORE_WIN_ANIMATION_STATE',
    BEFORE_WIN_ANIMATION_STATE = 'BEFORE_WIN_ANIMATION_STATE',
    POST_BEFORE_WIN_ANIMATION_STATE = 'POST_BEFORE_WIN_ANIMATION_STATE',

    PRE_SPECIAL_GAMES_INTRO_STATE = 'PRE_SPECIAL_GAMES_INTRO_STATE',
    SPECIAL_GAMES_TRIGGER = 'SPECIAL_GAMES_TRIGGER',
    PRE_SPECIAL_GAMES_RETRIGGER = 'PRE_SPECIAL_GAMES_RETRIGGER',
    PRE_WIN_SPECIAL_GAMES_RETRIGGER = 'PRE_WIN_SPECIAL_GAMES_RETRIGGER',
    SPECIAL_GAMES_RETRIGGER = 'SPECIAL_GAMES_RETRIGGER',
    SPECIAL_GAMES_START_INFO_STATE = 'SPECIAL_GAMES_START_INFO_STATE',
    SPECIAL_GAMES_INTRO_STATE = 'SPECIAL_GAMES_INTRO_STATE',
    SPECIAL_GAMES_SPECIAL_SYMBOL_STATE = 'SPECIAL_GAMES_SPECIAL_SYMBOL_STATE',
    SPECIAL_GAMES_INTRO_END_STATE = 'SPECIAL_GAMES_INTRO_END_STATE',
    POST_SPECIAL_GAMES_INTRO_STATE = 'POST_SPECIAL_GAMES_INTRO_STATE',

    SPECIAL_GAMES_COUNTER_SHOW = 'SPECIAL_GAMES_COUNTER_SHOW',
    SPECIAL_GAMES_COLLECTION = 'SPECIAL_GAMES_COLLECTION',
    SPECIAL_GAMES_COLLECT_INTRO = 'SPECIAL_GAMES_COLLECT_INTRO',

    PRE_SPECIAL_GAMES_OUTRO_STATE = 'PRE_SPECIAL_GAMES_OUTRO_STATE',
    SPECIAL_GAMES_OUTRO_STATE = 'SPECIAL_GAMES_OUTRO_STATE',
    SPECIAL_GAMES_SUMMARY_STATE = 'SPECIAL_GAMES_SUMMARY_STATE',
    POST_SPECIAL_GAMES_OUTRO_STATE = 'POST_SPECIAL_GAMES_OUTRO_STATE',

    PRE_STATIC_JACKPOT_WIN_STATE = 'PRE_STATIC_JACKPOT_WIN',
    STATIC_JACKPOT_WIN_STATE = 'STATIC_JACKPOT_WIN',
    POST_STATIC_JACKPOT_WIN_STATE = 'POST_STATIC_JACKPOT_WIN'
}
